var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNtext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.547,
    height: 52,
    viewBox: "0 0 218.547 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(-53 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-22.338 -109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(75.338 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M202.728,207.155a13.285,13.285,0,0,0-.064,14.409l2.895,4.76s1.8,1.93-1.158,3.216a18.316,18.316,0,0,1-4.7,1.479l.386,1.093,1.158,1.737s.9,2.959-2.895,3.538c0,0,1.994,1.994.9,3.8s-2.766,1.737-3.859,1.93a6.309,6.309,0,0,0,0,2.959c.386,1.672-.257,5.6-3.538,6.046s-4.953-.257-9.777-2.7-11.578-3.924-15.5-2.315a10.509,10.509,0,0,0-2.638,1.093,27.116,27.116,0,0,0,17.3,10.549c11.707,1.994,21.291-3.6,26.566-9.391s9.07-16.081,5.982-27.4S202.728,207.155,202.728,207.155Z",
    transform: "translate(-157.995 -207.155)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 2.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M173.363,259.189a2.892,2.892,0,0,0-.084.7,3.237,3.237,0,1,0,1.154-2.476l-4.98-3.676h-5c-.169.675-.31,1.36-.413,2.054h4.727Zm3.142-.722a1.426,1.426,0,1,1-1.416,1.425A1.425,1.425,0,0,1,176.5,258.467Z",
    transform: "translate(-163.189 -242.998)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M164.288,277.107c.094.516.206,1.032.338,1.538h17.359l1.529-1.266a2.517,2.517,0,0,0,1.313.365,2.593,2.593,0,1,0-2.476-3.376,3.055,3.055,0,0,0-.113.779,2.429,2.429,0,0,0,.15.872,1.5,1.5,0,0,0,.094.216l-1.05.872Zm19.4-1.96a1.1,1.1,0,0,1,.309-.779,1.128,1.128,0,0,1,.825-.366,1.144,1.144,0,0,1,.01,2.288h-.01a1.069,1.069,0,0,1-.731-.272,1.107,1.107,0,0,1-.394-.788A.254.254,0,0,1,183.691,275.148Z",
    transform: "translate(-164.288 -253.715)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M188.12,289.549l2.128-2.1a2,2,0,0,0,.867.2,2.021,2.021,0,1,0-2.021-2.021,2,2,0,0,0,.124.673l-1.727,1.7H167.2c.2.516.4,1.031.628,1.538Z",
    transform: "translate(-165.145 -258.675)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M182.829,237.286l2.959,4.429h6.464v1.11h3.8v-3.8h-3.8v1.144h-5.64l-1.929-2.887h12.759a3.218,3.218,0,1,0-.047-2.054H183.569l2.734-3.259h7.762v1.874L198,231.069l-3.937-3.091v1.939h-8.721l-4.459,5.315h-3.935l-5.3-4.858a19.317,19.317,0,0,0-1.05,1.81l5.589,5.1Zm17.652-2.513a1.425,1.425,0,0,1,0,2.851,1.362,1.362,0,0,1-.91-.338,1.431,1.431,0,0,1-.506-1.088,1.362,1.362,0,0,1,.384-.966A1.411,1.411,0,0,1,200.48,234.773Z",
    transform: "translate(-165.442 -227.978)",
    fill: "#b1891d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-109.566 -176.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M344.775,265.391l-3.592-.842q-3.121-.749-3.121-2.885a2.686,2.686,0,0,1,1.232-2.361,4.887,4.887,0,0,1,2.808-.835,5.626,5.626,0,0,1,3,.866,3.863,3.863,0,0,1,1.788,2.555l2.181-.647q-1.646-4.743-6.883-4.743a7.3,7.3,0,0,0-4.659,1.431,4.638,4.638,0,0,0-1.816,3.841,5,5,0,0,0,.661,2.579,4.455,4.455,0,0,0,1.612,1.67,9.888,9.888,0,0,0,2.442.923l3.844.947a4.882,4.882,0,0,1,2.033,1.031,2.469,2.469,0,0,1,.879,1.977,3.208,3.208,0,0,1-1.154,2.592,5.237,5.237,0,0,1-3.434.967q-4.363,0-5.672-3.926l-2.168.492q1.914,5.475,7.881,5.475a7.559,7.559,0,0,0,5.215-1.654A5.328,5.328,0,0,0,349.7,270.7Q349.7,266.574,344.775,265.391Z",
    transform: "translate(-102.188 -29.519)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M382.275,268.628a5.947,5.947,0,0,0-4.588,2.029,7.754,7.754,0,0,0-1.844,5.424,8.665,8.665,0,0,0,1.64,5.382,5.4,5.4,0,0,0,4.567,2.17,5.974,5.974,0,0,0,4.729-2.106,7.983,7.983,0,0,0,1.83-5.431,8.306,8.306,0,0,0-1.7-5.333A5.6,5.6,0,0,0,382.275,268.628Zm2.773,11.78a3.517,3.517,0,0,1-2.829,1.393,3.564,3.564,0,0,1-2.815-1.33q-1.141-1.33-1.14-4.413a6.514,6.514,0,0,1,1.14-4.258,3.523,3.523,0,0,1,2.787-1.344,3.661,3.661,0,0,1,2.8,1.33,6.314,6.314,0,0,1,1.2,4.286A6.785,6.785,0,0,1,385.048,280.408Z",
    transform: "translate(-126.352 -36.653)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M412.926,274.865V265.93h3.181V264.2h-3.181v-3.772l-2.055.2-.1,3.575h-2.519v1.731h2.519V274.5q0,4.311,4.124,4.311a15.755,15.755,0,0,0,2.027-.155v-1.745a10.86,10.86,0,0,1-1.717.155Q412.926,277.063,412.926,274.865Z",
    transform: "translate(-145.412 -31.83)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M441.638,270.556a5.679,5.679,0,0,0-4.483-1.928,6.042,6.042,0,0,0-4.7,2.092,8.947,8.947,0,0,0-.071,10.862,5.978,5.978,0,0,0,4.715,2.05,6.335,6.335,0,0,0,3.842-1.193,5.785,5.785,0,0,0,2.2-3.015L441.082,279a3.9,3.9,0,0,1-3.828,2.8,4.4,4.4,0,0,1-2.858-1.126q-1.351-1.126-1.351-4.349h10.331Q443.334,272.484,441.638,270.556Zm-8.494,4.124a4.894,4.894,0,0,1,1.288-3.181,3.746,3.746,0,0,1,2.794-1.182,3.4,3.4,0,0,1,2.1.655,3.624,3.624,0,0,1,1.239,1.583,6.187,6.187,0,0,1,.394,2.125Z",
    transform: "translate(-158.544 -36.653)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M473.011,269.257a7.125,7.125,0,0,0-2.062,3.047v-3.322h-1.943V283.2h2.21v-7.516a5.542,5.542,0,0,1,1.3-3.589,3.892,3.892,0,0,1,3.04-1.365H476v-2.111q-.536-.056-.873-.056A3.748,3.748,0,0,0,473.011,269.257Z",
    transform: "translate(-181.14 -36.613)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 2.379,
    height: 2.463,
    transform: "translate(296.98 227.373)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 2.21,
    height: 14.215,
    transform: "translate(297.078 232.369)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M515.766,274.441q0-3.209-1.232-4.511t-4.173-1.3q-5.531,0-6.277,3.927l2.041.352q.549-2.561,3.913-2.561a4.729,4.729,0,0,1,2.224.45,2.178,2.178,0,0,1,1.1,1.2,8.179,8.179,0,0,1,.261,2.442q-1.3-.056-1.886-.056-4.392,0-6.221,1.389a4.268,4.268,0,0,0-1.83,3.545,4.132,4.132,0,0,0,1.281,3.045,5,5,0,0,0,3.673,1.269,5.122,5.122,0,0,0,4.983-2.956q.127,1.886.253,2.561h2.182a12,12,0,0,1-.3-2.759Zm-3.385,6.034a4.2,4.2,0,0,1-3.286,1.454,3.179,3.179,0,0,1-2.259-.734,2.35,2.35,0,0,1-.781-1.778,2.754,2.754,0,0,1,1.45-2.511,8.009,8.009,0,0,1,4.068-.86q.7,0,2.055.084.042.536.042.931A4.983,4.983,0,0,1,512.381,280.475Z",
    transform: "translate(-201.538 -36.653)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M555.184,259.566h5.5v17.1h2.407v-17.1h5.517v-2.111H555.184Z",
    transform: "translate(-231.821 -30.082)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M592.418,269.257a7.123,7.123,0,0,0-2.062,3.047v-3.322h-1.943V283.2h2.21v-7.516a5.54,5.54,0,0,1,1.295-3.589,3.892,3.892,0,0,1,3.04-1.365h.451v-2.111q-.535-.056-.872-.056A3.747,3.747,0,0,0,592.418,269.257Z",
    transform: "translate(-251.362 -36.613)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M619.757,277.593a5.247,5.247,0,0,1-.577,2.442,4.644,4.644,0,0,1-1.443,1.724,3.3,3.3,0,0,1-1.935.605,2.825,2.825,0,0,1-1.935-.8,3.825,3.825,0,0,1-.879-2.906v-9.078h-2.21v9.087a6.056,6.056,0,0,0,1.244,4.086,4.289,4.289,0,0,0,3.422,1.437,4.841,4.841,0,0,0,4.525-3.11V283.8h2V269.585h-2.21Z",
    transform: "translate(-264.515 -37.215)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M651.151,275.046l-2.772-.5q-2.211-.408-2.21-1.982a1.749,1.749,0,0,1,.865-1.553,4.039,4.039,0,0,1,2.217-.555,3.467,3.467,0,0,1,3.589,2.224l2.027-.436q-1.084-3.617-5.714-3.617a5.733,5.733,0,0,0-3.828,1.2,3.764,3.764,0,0,0-1.422,2.991,3.418,3.418,0,0,0,1.042,2.6,5.467,5.467,0,0,0,2.8,1.323l3,.569q2.436.45,2.436,2.122a1.962,1.962,0,0,1-.957,1.743,4.216,4.216,0,0,1-2.336.618q-3.744,0-4.447-2.688l-2.111.436q1.2,4.082,6.249,4.082a7.042,7.042,0,0,0,4.307-1.205,3.763,3.763,0,0,0,1.619-3.165Q655.5,275.836,651.151,275.046Z",
    transform: "translate(-283.656 -36.653)",
    fill: "#b1891d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M681.287,277.063q-2.28,0-2.28-2.2V265.93h3.181V264.2h-3.181v-3.772l-2.055.2-.1,3.575h-2.52v1.731h2.52V274.5q0,4.311,4.124,4.311a15.745,15.745,0,0,0,2.027-.155v-1.745A10.852,10.852,0,0,1,681.287,277.063Z",
    transform: "translate(-301.892 -31.83)",
    fill: "#b1891d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNtext);
export default __webpack_public_path__ + "static/media/logoNtext.e3d05c14c5a63ae6631925342fb71d52.svg";
export { ForwardRef as ReactComponent };